export default __webpack_public_path__ + "static/media/logo-login.4ef2b932.svg";